export default "__VITE_ASSET__BB7cMTiL__"